// extracted by mini-css-extract-plugin
module.exports = {"activities":"activities_activities__1BNjd","formButton":"activities_formButton__UhqG_","box":"activities_box___GVr4"};